import { useTranslation } from "react-i18next";

import { Section, SectionHeader, SectionTitle } from "@/blocks/Section";
import { SkeletonLabel } from "@/components/Skeleton";
import { useAnalyticsCallDisconnectedBy } from "@/hooks/useAnalyticsCallDisconnectedBy/useAnalyticsCallDisconnectedBy";
import { useCall } from "@/hooks/useCall/useCall";

function SectionDisconnectedByBody() {
  const { t } = useTranslation();
  const { call } = useCall();

  const { disconnectedBy, loading, error } = useAnalyticsCallDisconnectedBy(
    call?.id ?? "",
    call?.createdAt ?? ""
  );

  if (loading) {
    return <SkeletonLabel w={80} h={18} data-test="disconnected-by-skeleton" />;
  }

  if (error || !disconnectedBy) {
    return null;
  }

  const displayValue =
    disconnectedBy === "AGENT"
      ? t("call_context.disconnected_by_agent")
      : t("call_context.disconnected_by_external");

  return <span className="text-sm font-medium">{displayValue}</span>;
}

export function SectionDisconnectedBy() {
  const { t } = useTranslation();
  const { call } = useCall();

  if (!call) {
    return null;
  }

  return (
    <Section data-test="disconnected-by-section">
      <SectionHeader>
        <SectionTitle>{t("call_context.disconnected_by")}</SectionTitle>
      </SectionHeader>
      <SectionDisconnectedByBody />
    </Section>
  );
}
